var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.005 6.69C8.39 6.69 7.795 6.59 7.24 6.41C7.065 6.35 6.87 6.395 6.735 6.53L5.95 7.515C4.535 6.84 3.21 5.565 2.505 4.1L3.48 3.27C3.615 3.13 3.655 2.935 3.6 2.76C3.415 2.205 3.32 1.61 3.32 0.995C3.32 0.725 3.095 0.5 2.825 0.5H1.095C0.825 0.5 0.5 0.62 0.5 0.995C0.5 5.64 4.365 9.5 9.005 9.5C9.36 9.5 9.5 9.185 9.5 8.91V7.185C9.5 6.915 9.275 6.69 9.005 6.69Z",
    fill: "#73788C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.39c9563591cf56369bfa658d4f125883.svg";
export { ForwardRef as ReactComponent };